import i, { css as t, createGlobalStyle as s } from "styled-components";
import a from "./utils/colors.js";
import { device as r } from "./utils/device.js";
const o = i.div``, l = i(o)``, c = {
  Small: i(o)`
    margin-bottom: 8px;
  `,
  Medium: i(o)`
    margin-bottom: 16px;
  `,
  Large: i(o)`
    margin-bottom: 24px;
  `
}, e = t`
  pointer-events: none;
`, d = t`
  ${e};
  width: 100%;
  height: auto;
  position: relative;
`, p = t`
  ${e};
  width: auto;
  height: 100%;
`, y = t`
  /* This timing applies on the way IN */
  transition-timing-function: ease-out;

  /* A litttttle slower on the way in */
  transition: 0.5s;

  /* Move into place */
  transform: translateX(0);
`, m = t`
  /* This timing applies on the way OUT */
  transition-timing-function: ease-in;

  /* Quick on the way out */
  transition: 0.5s;

  /* Hide thing by pushing it outside by default */
  transform: translateX(-100%);
`, h = t`
  visibility: hidden;
  opacity: 0;
  transition: visibility 2s linear 300ms, opacity 0.5s;
  opacity: 0;
  z-index: -1;
`, b = t`
  visibility: visible;
  opacity: 0.75;
  transition: visibility 0s linear 0s, opacity 0.5s;
  z-index: 9;
  width: 100vw;
  height: 100vh;
`, u = t`
  color: ${a.brown};
  text-decoration: underline;
`, f = s`
  body {
    @media ${r.isMobile} {
      ${(n) => n.isEnabled && t`position: fixed; overflow: hidden; overflow-y: scroll;`}
    }
}`, x = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseWrapper: o,
  FixedBody: f,
  Spacer: c,
  WrapperDiv: l,
  fadeIn: b,
  fadeOut: h,
  fullHeightStyle: p,
  fullWidthStyle: d,
  textFocus: u,
  transitionHidden: m,
  transitionVisible: y
}, Symbol.toStringTag, { value: "Module" }));
export {
  o as B,
  f as F,
  c as S,
  l as W,
  p as a,
  y as b,
  b as c,
  h as d,
  m as e,
  d as f,
  x as s,
  u as t
};
